var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/slider-macros.j2"] = require( "macros/slider-macros.j2" );
dependencies["carousel-slider/carousel-slides.j2"] = require( "carousel-slider/carousel-slides.j2" );
dependencies["carousel-slider/carousel-pagination.j2"] = require( "carousel-slider/carousel-pagination.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/carousel-slider/carousel-product-image-container.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/slider-macros.j2", false, "product/templates/carousel-slider/carousel-product-image-container.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("create_slider_arrows")) {
var t_4 = t_1.create_slider_arrows;
} else {
cb(new Error("cannot import 'create_slider_arrows'")); return;
}
context.setVariable("create_slider_arrows", t_4);
output += "\n\n<div class=\"o-carousel o-carousel--product-image js-carousel-zoom--product-image js-modal-product-image-zoom-fix\">\n\n    ";
env.getTemplate("carousel-slider/carousel-slides.j2", false, "product/templates/carousel-slider/carousel-product-image-container.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n</div>\n\n";
output += "\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen")) {
output += "\n\n\t";
output += runtime.suppressValue((lineno = 11, colno = 22, runtime.callWrap(t_4, "create_slider_arrows", context, [runtime.makeKeywordArgs({"classPrefix": "carousel","disablePrev": runtime.contextOrFrameLookup(context, frame, "False")})])), env.opts.autoescape);
output += "\n\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")) {
output += "\n\n\t";
output += runtime.suppressValue((lineno = 15, colno = 22, runtime.callWrap(t_4, "create_slider_arrows", context, [runtime.makeKeywordArgs({"classPrefix": "carousel","arrowsOutside": runtime.contextOrFrameLookup(context, frame, "True"),"disablePrev": runtime.contextOrFrameLookup(context, frame, "True"),"isSmallArrow": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
output += "\n\n";
;
}
;
}
output += "\n\n";
output += "\n";
if((lineno = 20, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.browseDisplayOptions.showZoomIconOnProductImage",runtime.contextOrFrameLookup(context, frame, "False")]))) {
output += "\n\n     <div class=\"o-carousel__show-zoom js-shadow-zoom__open u-large--hide\">\n\n          <svg class=\"i-zoom\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 25 25\" xml:space=\"preserve\" enable-background=\"new 0 0 25 25\" role=\"img\" aria-hidden=\"true\">\n               <defs>\n                    <rect id=\"SVGID_1_\" width=\"25\" height=\"25\"></rect>\n               </defs>\n\n               <clipPath id=\"SVGID_2_\">\n\n                    <use xlink:href=\"#SVGID_1_\" overflow=\"visible\"></use>\n\n               </clipPath>\n\n               <line class=\"st0\" x1=\"0\" y1=\"12.5\" x2=\"25\" y2=\"12.5\"></line>\n\n               <line class=\"st0\" x1=\"12.5\" y1=\"0\" x2=\"12.5\" y2=\"25\"></line>\n\n          </svg>\n\n     </div>\n\n";
;
}
output += "\n\n";
if(!runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")) {
output += "\n\n\t";
output += "\n\t";
env.getTemplate("carousel-slider/carousel-pagination.j2", false, "product/templates/carousel-slider/carousel-product-image-container.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n";
})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/carousel-slider/carousel-product-image-container.j2"] , dependencies)